var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "video_list2 personal-video"
  }, [_c('ul', {
    staticClass: "clearfix2"
  }, [_c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showShortsActive == true,
      expression: "showShortsActive == true"
    }],
    staticClass: "m_span6"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": _vm.getLink('/squashthehate/index.html')
    },
    on: {
      "click": function click($event) {
        return _vm.KEWLSensorTrack('/squashthehate/index.html');
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/app/spa/images/sqvashthehate.jpg"
    }
  }), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _vm._l(_vm.recommendList, function (recommend, index) {
    return _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.replayVideo == true,
        expression: "replayVideo == true"
      }],
      key: index,
      staticClass: "xs_span12"
    }, [_c('a', {
      staticClass: "item",
      attrs: {
        "href": _vm.getLiveRoomLink(recommend.vdoid),
        "target": _vm.target
      }
    }, [_c('img', {
      attrs: {
        "src": recommend.videocapture
      }
    }), _vm._v(" "), _vm._m(1, true), _vm._v(" "), _c('span', {
      staticClass: "live_watch"
    }, [_c('i', {
      staticClass: "f"
    }), _c('i', {
      staticClass: "s"
    }), _c('i', {
      staticClass: "t"
    }), _vm._v(" " + _vm._s(recommend.watchnumber))]), _vm._v(" "), _c('span', {
      staticClass: "replay-video"
    }, [_vm._v(_vm._s(_vm.$t("REPLAY")))]), _vm._v(" "), _c('div', {
      staticClass: "info clear"
    }, [_c('p', [_c('span', {
      staticClass: "icon"
    }), _vm._v(" "), _c('span', {
      staticClass: "nickname"
    }, [_vm._v(_vm._s(recommend.uname))])]), _vm._v(" "), _c('p', {
      staticClass: "desc"
    }, [_vm._v(_vm._s(recommend.title)), _c('span', {
      staticClass: "video-time"
    }, [_vm._v("00:54:24")])])])])]);
  })], 2), _vm._v(" "), _vm.shortsNoData ? _c('div', {
    staticClass: "no_data"
  }, [_vm._v(_vm._s(_vm.$t("noData")))]) : _vm._e(), _vm._v(" "), !_vm.shortsNoData && _vm.shortsNoMoreData ? _c('div', {
    staticClass: "no_more_data"
  }, [_vm._v(_vm._s(_vm.$t("noMoreData")) + "\n    ")]) : _vm._e()]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "play_bg"
  })]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "mask"
  }, [_c('div', {
    staticClass: "play_bg"
  })]);
}];
export { render, staticRenderFns };